import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import authService from "../services/authService";
import PatientTable from "../components/Dashboard/PatientTable/PatientTable";
import Statistics from "../components/Dashboard/Statistics/Statistics";
import { patients } from "../data/patients";
import "./AdminDashboard.css";

export default function AdminDashboard() {
  const [adminData, setAdminData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if admin is authenticated
    if (!authService.isAdminAuthenticated()) {
      navigate("/login", { replace: true });
      return;
    }

    // Get admin data from localStorage or API
    const admin = authService.getCurrentAdmin();
    if (admin) {
      setAdminData(admin);
    }

    setIsLoading(false);
  }, [navigate]);

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="dashboard">
      <Statistics />
      <PatientTable rows={patients} />
    </div>
  );
}
